import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {PartnerSummaryConverter} from "../../../../../partner/common/api/converter/partnerSummary.converter";
import {MedicalRecordPainIntensityModel} from "../model/medicalRecordPainIntensity.model";
import {DateConverter} from "../../../../../common/converter/date.converter";

export class MedicalRecordPainIntensityConverter extends HttpModelConverter<MedicalRecordPainIntensityModel>{

    protected createInstance(): MedicalRecordPainIntensityModel {
        return new MedicalRecordPainIntensityModel();
    }

    protected enrichObject(result: MedicalRecordPainIntensityModel, src: MedicalRecordPainIntensityModel) {
        result.partner = new PartnerSummaryConverter().convert(src.partner);
        result.date = new DateConverter().convert(src.date);
    }
}